import React from 'react'
import './Navbar.scss'
import { images } from '../../constants'
import { HiAdjustments, HiMenuAlt4, HiOutlineMenu, HiX } from 'react-icons/hi'
import { useState } from 'react'
import { motion } from 'framer-motion'

const Navbar = () => {
  const [toogle, setToggle] = useState(false)
  return (
    <nav className='app__navbar'>
        <div className='app__navbar-logo'>
            <img src={images.logo} alt="LOGO" />

        </div>
        <ul className='app__navbar-links'>
          {['home', 'about',  'work', 'skills','contact'].map((item) => (
            <li className='app__flex p-text' key={`link-${item}`}>
              <div/>
              <a href={`/#${item}`}>{item}</a>
            </li>
          ))}
        </ul>

        <div className="app__navbar-menu">
          <HiOutlineMenu onClick={() => setToggle(true)}/>
          {toogle && (
            <motion.div 
            whileInView={{x:[300, 0]}}
            transition={{duration: 0.05, ease: 'easeOut'}}>
              <HiX onClick={()=>setToggle(false)} />
              
              <ul className='app__navbar-links'>
              {['home', 'about',  'work', 'skills', 'contact'].map((item) => (
                <li  key={item}>
                  <a href={`/#${item}`} onClick={()=>setToggle(false)}>{item}</a>
                
                </li>
              ))}
              </ul>
            </motion.div>
          )}
        </div>
    </nav>
  )
}

export default Navbar